import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { JinkPlayerComponent } from '@streaming/jink-player';

import ProfileStore from 'stores/ProfileStore';
import FirebaseStore from 'stores/FirebaseStore';


const JinkPlayerTransformContainer = ({ forwardedRef, source, muted, onJinkPlayerInit, volume }) => {
  if (!source?.uri) {
    // not ready yet
    return null;
  }

  const username = ProfileStore?.currentUser?.username ?? 'GUEST';
  const room = ProfileStore?.performerDetails?.username ?? '';
  const streamingProvider = FirebaseStore.isStreamingSaas ? FirebaseStore.streamingProvider?.toLowerCase() : 'wowza';
  const { showType } = FirebaseStore;

  const transformed = {
    autoplay: false,
    disablePictureInPicture: true,
    muted,
    volume,
    source: [{ ...source, [streamingProvider]: source[streamingProvider] || true }],
    metricsInfo: {
      tenant: 'CAM4',
      room,
      username,
      showType,
    },
    onInit: onJinkPlayerInit,
  };

  return <JinkPlayerComponent ref={forwardedRef} {...transformed} onInit={onJinkPlayerInit} />;
};

JinkPlayerTransformContainer.propTypes = {
  forwardedRef: PropTypes.object.isRequired,
  muted: PropTypes.bool.isRequired,
  source: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  volume: PropTypes.number.isRequired,
  onJinkPlayerInit: PropTypes.func.isRequired,
};

export default observer(JinkPlayerTransformContainer);
